<template>
  <div class="client-scheduler">
    <div class="row">
      <div class="col-lg-8 col-12">
        <cronofy-availability-viewer
          :client="client"
          :selected-slot="selectedSlot"
          @set-selected-slot="setSelectedSlot"
        />
      </div>
      <div class="dashboard-card col-lg-4 col-12">
        <client-event-card
          :selected-slot="selectedSlot"
          :saving="saving"
          @confirm-clicked="scheduleSession"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import ClientEventCard from '@/components/scheduling/ClientEventCard.vue';
import CronofyAvailabilityViewer from '@/components/scheduling/CronofyAvailabilityViewer.vue';

export default {
    name: 'ClientScheduler',
    components: {
      ClientEventCard,
      CronofyAvailabilityViewer
    },
    props: {
        client: {
            type: Object,
            required: true
        },
        counselorId: {
          type: Number,
          required: true
        }
    },
    data() {
      return {
        counselorClient: new CounselorClient(this.$http),
        saving: false,
        selectedSlot: {}
      }
    },
    methods: {
      setSelectedSlot(slotData) {
        this.selectedSlot = slotData;
      },
      scheduleSession() {
        this.saving = true;
        this.counselorClient.scheduleSession(this.counselorId, this.client.id, this.selectedSlot.start, this.selectedSlot.end).then(() => {
          this.$store.commit('setGlobalAlert', {
            msg: 'Session scheduled!',
          });
          this.logAppointmentRequest(this.client.id, this.selectedSlot.start)
        }).catch(ex => {
          const message = ex && ex.body && ex.body.errors && ex.body.errors.Session ?
                          ex.body.errors.Session[0] :
                          'Failed to request an appointment. Please try again!';
          this.$store.commit('setGlobalAlert', {
            msg: message,
            error: true,
          });
        }).finally(() => {
          this.saving = false;
          this.$emit('clear-scheduling', {});
        });
      },
      logAppointmentRequest(id, startDate) {
        this.$gtag.event('appointment_request', {
          student_id: id,
          counselor_id: this.counselorId,
          start_time: startDate
        });
      },
    }
}
</script>

<style lang="scss">
.client-scheduler {
  .scheduler {
    .scheduler__navigation {
      position: absolute;
      top: 0;
      right: 0;
    }

    .scheduler__month-labels {
      padding-top: 20px;
    }

    .scheduler__example.scheduler__example--unavailable {
      background-color: #fff;
    }

    .scheduler__time-text {
      color: #fff;
    }

    .scheduler__month-labels {
      padding-top: 0px;

      .scheduler__month-label {
        font-size: 30px;
      }
    }
  }

  .dashboard-card {
    padding: 0;
    margin-top: 5.8rem;
  }
}

</style>
